var cao_crm_site_lang = CondoCalendarPlugin.cao_crm_current_site_lang;
var regions = [{
    "Name": "Algoma"
},
{
    "Name": "Brant"
},
{
    "Name": "Bruce"
},
{
    "Name": "Carleton"
},
{
    "Name": "Cochrane"
},
{
    "Name": "Dufferin"
},
{
    "Name": "Dundas"
},
{
    "Name": "Durham"
},
{
    "Name": "Elgin"
},
{
    "Name": "Essex"
},
{
    "Name": "Frontenac"
},
{
    "Name": "Glengarry"
},
{
    "Name": "Grenville"
},
{
    "Name": "Grey"
},
{
    "Name": "Grey South"
},
{
    "Name": "Haldimand"
},
{
    "Name": "Haliburton"
},
{
    "Name": "Halton "
},
{
    "Name": "Hastings"
},
{
    "Name": "Huron"
},
{
    "Name": "Kenora"
},
{
    "Name": "Kent"
},
{
    "Name": "Lambton"
},
{
    "Name": "Lanark"
},
{
    "Name": "Lanark North / Lanark Nord"
},
{
    "Name": "Lanark South / Lanark Sud"
},
{
    "Name": "Leeds"
},
{
    "Name": "Lennox"
},
{
    "Name": "London"
},
{
    "Name": "Manitoulin"
},
{
    "Name": "Metropolitan Toronto"
},
{
    "Name": "Middlesex"
},
{
    "Name": "Middlesex West / Middlesex Ouest"
},
{
    "Name": "Muskoka"
},
{
    "Name": "Newcastle"
},
{
    "Name": "Niagara North / Niagara Nord"
},
{
    "Name": "Niagara South / Niagara Sud"
},
{
    "Name": "Nipissing"
},
{
    "Name": "Norfolk"
},
{
    "Name": "Northumberland"
},
{
    "Name": "Northumberland East / Northumberland Est"
},
{
    "Name": "Northumberland West / Northumberland Ouest"
},
{
    "Name": "Ontario"
},
{
    "Name": "Ottawa-Carleton"
},
{
    "Name": "Oxford"
},
{
    "Name": "Parry Sound"
},
{
    "Name": "Peel"
},
{
    "Name": "Perth"
},
{
    "Name": "Peterborough"
},
{
    "Name": "Port Hope"
},
{
    "Name": "Prescott"
},
{
    "Name": "Prince Edward"
},
{
    "Name": "Rainy River"
},
{
    "Name": "Renfrew"
},
{
    "Name": "Russell"
},
{
    "Name": "Simcoe"
},
{
    "Name": "Stormont"
},
{
    "Name": "Sudbury"
},
{
    "Name": "Thunder Bay"
},
{
    "Name": "Timiskaming"
},
{
    "Name": "Toronto"
},
{
    "Name": "Victoria"
},
{
    "Name": "Waterloo"
},
{
    "Name": "Waterloo North / Waterloo Nord"
},
{
    "Name": "Waterloo South / Waterloo Sud"
},
{
    "Name": "Wellington"
},
{
    "Name": "Wellington North / Wellington Nord"
},
{
    "Name": "Wentworth"
},
{
    "Name": "York"
},
{
    "Name": "York North"
},
{
    "Name": "York Region"
}
];

(function ($) {
    $(document).ready(function () {

        //Populate Regions dropdown
        for (var i = 0; i < regions.length; i++) {
            var regionSet = "<option>" + regions[i]["Name"] + "</option>";
            $("#LegalRegion").append(regionSet);
            $("#OperatingRegion").append(regionSet);
        }

        //Populate values if it was from a search


        //Populate checkbox values from session storage
        if (typeof (Storage) !== "undefined") {
            $("#Terms").attr("checked", sessionStorage.getItem("termsofuse"));
            $("#verified").attr("checked", sessionStorage.getItem("norobot"));
            if ($("#verified").attr("checked") == "checked" || $("#verified").attr("checked") == "checked") {
                $("#checkbox-border, #checkbox-checkmark, #checkmark").fadeIn();
            } else {
                $("#checkbox-checkmark, #checkmark").fadeOut();
            }
        }

        //Max length of Postcal Code field is 7
        $("#AddressPostalCode").on("change keyup", function () {
            if ($(this).val().length > 7) {
                $(this).val($(this).val().substr(0, 7));
            }
        });

        function triggerGoogleAnalyticsEvent(eventLabel) {
            let language = cao_crm_site_lang;
            let labelWithLanguage = language === 'en' ? `${eventLabel} (English)` : `${eventLabel} (French)`;
            if (typeof gtag === "function") {
                gtag('event', 'Search', {
                    event_category: $('.condo-calendar-body').length ? 'CAO Calendar App Search' : 'Public Registry Search',
                    event_action: 'click',
                    event_label: labelWithLanguage,
                });
            }
        }

        $("#registry-search-submit").click(function () {
            if (validateSearch()) {
                var queryString = "";
                //Try to parse out Legal Search fields first
                if ($("#rb_legalName").prop("checked")) {
                    triggerGoogleAnalyticsEvent('Legal Name');
                    if ($(this).data('url').includes('?'))
                        queryString = "&search_type=legal&regionName=" + $("#LegalRegion option:selected").text() + "&number=" + $.trim($("#LegalNumber").val());
                    else
                        queryString = "?search_type=legal&regionName=" + $("#LegalRegion option:selected").text() + "&number=" + $.trim($("#LegalNumber").val());
                } else if ($("#rb_operatingName").prop("checked")) {
                    triggerGoogleAnalyticsEvent('Operating Name');
                    if ($(this).data('url').includes('?'))
                        queryString = "&search_type=operating&operatingName=" + $.trim($("#OperatingName").val());
                    else
                        queryString = "?search_type=operating&operatingName=" + $.trim($("#OperatingName").val());

                    if ($("#OperatingRegion option:selected").text() !== "") {
                        queryString += "&regionName=" + $("#OperatingRegion option:selected").text();
                    }
                } else if ($("#rb_directorName").prop("checked")) {
                    triggerGoogleAnalyticsEvent('Director Name');
                    if ($(this).data('url').includes('?'))
                        queryString = "&search_type=director&firstName=" + encodeURIComponent($("#DirectorFirstName").val().trim()) +
                            "&lastName=" + encodeURIComponent($("#DirectorLastName").val().trim());
                    else
                        queryString = "?search_type=director&firstName=" + encodeURIComponent($("#DirectorFirstName").val().trim()) +
                            "&lastName=" + encodeURIComponent($("#DirectorLastName").val().trim());
                } else if ($("#rb_municipalAddress").prop("checked")) {
                    triggerGoogleAnalyticsEvent('Municipal Address');
                    var newPostal = $("#AddressPostalCode").val().trim().replaceAll(" ", "");
                    newPostal = newPostal.substring(0, 3) + " " + newPostal.substring(3, 6);
                    if ($(this).data('url').includes('?'))
                        queryString = "&search_type=municipal&city=" + encodeURIComponent($("#AddressCity").val().trim()) +
                            "&postalCode=" + encodeURIComponent(newPostal);
                    else
                        queryString = "?search_type=municipal&city=" + encodeURIComponent($("#AddressCity").val().trim()) +
                            "&postalCode=" + encodeURIComponent(newPostal);
                } else {
                    //Do nothing
                }

                //Store Checkbox values in local storage
                if (typeof (Storage) !== "undefined") {
                    sessionStorage.setItem("termsofuse", true);
                    sessionStorage.setItem("norobot", true);
                }
                // console.log($(this).data('url') + queryString + "&sorting&skipCount=0&maxResultCount=5");
                window.location.href = $(this).data('url') + queryString + "&sorting&skipCount=0&maxResultCount=5";
            }
        });

        $("#registry-search-clear").click(function () {
            $("#LegalRegion, #LegalNumber").val("");
            $("#OperatingRegion, #OperatingName").val("");
            $("#DirectorFirstName, #DirectorLastName").val("");
            $("#AddressCity, #AddressPostalCode").val("");
            $("#search-alert").html("").hide();
        });

        $("#TermsOfUse").click(function () {
            $("#TermsModal").modal('show');
        });

        $("input, select").keydown(function (e) {
            if (e.which == 13 && $("#registry-search-submit").attr("disabled") !== "disabled") {
                $("#LegalRegion").change();
                $("#LegalNumber").change();
                $("#OperatingRegion").change();
                $("#OperatingName").change();

                $("#registry-search-submit").click();
            }
        });

        //Hide or show section based on selected rb option
        $('#rb_legalName').on("click", function () {
            $('#section_legalName').show();
            $('#section_operatingName').hide();
            $('#section_directorName').hide();
            $('#section_municipalAddress').hide();
            $("#registry-search-clear").trigger("click");
        });
        $('#rb_operatingName').on("click", function () {
            $('#section_legalName').hide();
            $('#section_operatingName').show();
            $('#section_directorName').hide();
            $('#section_municipalAddress').hide();
            $("#registry-search-clear").trigger("click");
        });
        $('#rb_directorName').on("click", function () {
            $('#section_legalName').hide();
            $('#section_operatingName').hide();
            $('#section_directorName').show();
            $('#section_municipalAddress').hide();
            $("#registry-search-clear").trigger("click");
        });
        $('#rb_municipalAddress').on("click", function () {
            $('#section_legalName').hide();
            $('#section_operatingName').hide();
            $('#section_directorName').hide();
            $('#section_municipalAddress').show();
            $("#registry-search-clear").trigger("click");
        });

        //Default select Legal Name rb
        $('#rb_legalName').trigger("click");
    });

    function validateSearch() {
        var errorMessages = "";
        $("#search-alert").html("").hide();



        errorMessages = validateSearchCriteria(errorMessages);

        if (!$("#Terms").prop("checked")) {
            errorMessages += cao_crm_site_lang === 'en' ? "<li>You must agree to the terms of use.</li>" : "<li>Vous devez accepter les conditions d'utilisation.</li>";
        }

        var response = grecaptcha.getResponse();
        if (response.length <= 0) {
            errorMessages += cao_crm_site_lang === 'en' ? "<li>reCAPTCHA is incorrect. Please try again.</li>" : "<li>Le texte reCAPTCHA est incorrect. Veuillez essayer à nouveau.</li>";
        }

        if (errorMessages != "") {
            $("#search-alert").html('<ul style="margin-bottom:0">' + errorMessages + "</ul>").show();
            return false;
        }

        return true;
    }

    function validateSearchCriteria(errorMessages) {
        errorMessages = validateLegalNameSearch(errorMessages);
        errorMessages = validateOperatingNameSearch(errorMessages);
        errorMessages = validateOperatingNameBlockedTerms(errorMessages);
        errorMessages = validateDirectorNameSearch(errorMessages);
        errorMessages = validateMunicipalAddressSearch(errorMessages);

        return errorMessages;
    }

    function validateLegalNameSearch(errorMessages) {
        if ($("#rb_legalName").prop("checked")) {
            console.log("LegalName is checked");
            if ($("#LegalRegion option:selected").text() === "") {
                errorMessages += cao_crm_site_lang === 'en' ? "<li>You must select a region.</li>" : "<li>Vous devez sélectionner une région.</li>";
            }

            if ($.trim($("#LegalNumber").val()) === "") {
                errorMessages += cao_crm_site_lang === 'en' ? "<li>You must enter a number.</li>" : "<li>Vous devez entrer un numéro.</li>";
            } else {
                //only accept numbers
                let regex = /^[0-9]*$/;
                let match = regex.exec($.trim($("#LegalNumber").val()));
                if (!match) {
                    errorMessages += cao_crm_site_lang === 'en' ? "<li>You must enter a number.</li>" : "<li>Vous devez entrer un numéro.</li>";
                }
            }
        }

        return errorMessages;
    }

    function validateOperatingNameSearch(errorMessages) {
        if ($("#rb_operatingName").prop("checked")) {
            if ($.trim($("#OperatingName").val()) === "") {
                errorMessages += cao_crm_site_lang === 'en' ? "<li>You must indicate an operating name.</li>" : "<li>Vous devez indiquer un nom commercial.</li>";
            } else {
                if ($.trim($("#OperatingName").val()).length <= 2) {
                    errorMessages += cao_crm_site_lang === 'en' ? "<li>The operating name has to be greater than two characters.</li>" : "<li>Vous devez indiquer un nom commercial</li>";
                }

                if ($.trim($("#OperatingName").val()).toLowerCase() === "the") {
                    errorMessages += cao_crm_site_lang === 'en' ? "<li>The operating name cannot be the word 'the'.</li>" : "<li>Vous devez indiquer un nom commercial</li>";
                }
            }
        }
        return errorMessages;
    }

    function validateOperatingNameBlockedTerms(errorMessages) {
        if ($("#rb_operatingName").prop("checked")) {
            var blockedTermsRegEx = /^no.$|^corporation$|^condominium$|^condo$|^con$|^cond$|^condom$|^condomi$|^condomi$|^condomin$|^condomini$|^condominiu$|^corp$|^cor$|^corpo$|^corpo$|^corpor$|^corpora$|^corporat$|^corporati$|^corporatio$/gi;
            var operatingName = $.trim($("#OperatingName").val());
            var matches = operatingName.match(blockedTermsRegEx);
            if (matches != null && matches.length > 0) {
                errorMessages += cao_crm_site_lang === 'en' ? "<li>The following words can't be used in the operating name search box: " + matches.join(',') + "</li>" : "<li>The following words can't be used in the operating name search box: " + matches.join(',') + "</li>";
            }
        }
        return errorMessages;
    }

    function validateDirectorNameSearch(errorMessages) {
        if ($("#rb_directorName").prop("checked")) {
            if ($.trim($("#DirectorFirstName").val()) === "" || $.trim($("#DirectorLastName").val()) === "") {
                errorMessages += cao_crm_site_lang === 'en' ? "<li>You must provide the full spelling of a first and a last name in order to search for a director.</li>" : "<li>Vous devez fournir un prénom et d'un nom de famille complet afin de rechercher un réalisateur.</li>";
            }
        }
        return errorMessages;
    }

    function validateMunicipalAddressSearch(errorMessages) {
        if ($("#rb_municipalAddress").prop("checked")) {
            if ($.trim($("#AddressCity").val()) === "") {
                errorMessages += cao_crm_site_lang === 'en' ? "<li>You must provide a city.</li>" : "<li>Vous devez fournir une ville.</li>";
            }

            if ($.trim($("#AddressPostalCode").val()) === "") {
                errorMessages += cao_crm_site_lang === 'en' ? "<li>You must provide a postal code.</li>" : "<li>Vous devez fournir un code postal.</li>";
            } else {
                //Canadian postal codes can't contain the letters D, F, I, O, Q, or U, and cannot start with W or Z
                let regex = /[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy][0-9][ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz] ?[0-9][ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz][0-9]/;
                let match = regex.exec($.trim($("#AddressPostalCode").val()));
                if (!match) {
                    errorMessages += cao_crm_site_lang === 'en' ? "<li>Invalid Postal Code. The postal code must be entered with the format A1A1A1 or A1A 1A1. Canadian postal codes cannot contain the letters D, F, I, O, Q, or U, and cannot start with the letters W or Z.</li>" : "<li>Code postal invalide : Le code postal doit être saisi dans le format A1A1A1 ou A1A 1A1. Les codes postaux canadiens ne peuvent pas contenir les lettres D, F, I, O, Q, or U, et ne peuvent pas commencer par les lettres W ou Z.</li>";
                }
            }

        }

        return errorMessages;
    }
})(jQuery);